module.exports = __webpack_public_path__ + "static/media/高分四号卫星.073fe903.png";